import React from 'react';

import moment from 'moment'

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {DateInput, Title, required, DateTimeInput} from 'react-admin';
import {ReportForm, IFrameHtmlReport, downloadFile} from '../../components';
import env from '../../env';

class PaymentSchoolReport extends React.Component {
  state = {
    openHtmlReport: false,
    htmlReportUrl: '',
    fromDate: moment().format('YYYY-MM-DD 00:00'),
    toDate: moment().format('YYYY-MM-DD 23:59:59'),
    isLoading: false
  };

  getReportUrl = (type) => {
    const params = {
      type,
      pFromDate: moment(this.state.fromDate).format("YYYY-MM-DD HH:mm:ss"),
      pToDate: moment(this.state.toDate).format("YYYY-MM-DD HH:mm:ss")
    }

    const urlParams = new URLSearchParams(params)
    return `${env.baseURL}/reports/payments/bySchool?${urlParams}`;
  }

  excelReport = () => {
    this.setState({isLoading: true})
    downloadFile(this.getReportUrl('XLS'), 'bao_cao_thanh_toan_toan_truong.xlsx').finally(()=> this.setState({isLoading: false}))
  }

  validate = (values) => {
    const errors = {};
    // Validate
    if (values.fromDate && values.toDate && (values.fromDate > values.toDate) ){
      errors.toDate = 'To date must be greater than From date'
    }
    // Copy input values to params
    this.setState({
      fromDate: values.fromDate,
      toDate: values.toDate,
    });

    return errors;
  }
  
  render() {
    return (
      <Card>
        <Title title="resources.paymentSchoolReport.name" />
        <CardContent>
          <p>Dữ liệu báo cáo theo kế hoạch thu, tính tổng số học sinh đã đóng, chưa đóng theo tháng của kế hoạch, không phải theo ngày thanh toán.</p>
          <ReportForm params={this.state}
            validate={this.validate} 
            excelReport={this.excelReport}
                      isLoading={this.state.isLoading}
          >
            <Grid container spacing={8}>
              <Grid item xs={12} sm={6} >
                <DateTimeInput label="resources.common.fromDate" source="fromDate" validate={required()} {...this.props} />
              </Grid>
              <Grid item xs={12} sm={6} >
                <DateTimeInput label="resources.common.toDate" source="toDate" validate={required()} {...this.props} />
              </Grid>

            </Grid>
          </ReportForm>

          {
            this.state.openHtmlReport && 
            <IFrameHtmlReport src={this.state.htmlReportUrl} />
          }
        </CardContent>
      </Card>      
    )
  }
}

export default PaymentSchoolReport;

